import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-eleven',
  templateUrl: './home-page-eleven.component.html',
  styleUrls: ['./home-page-eleven.component.scss']
})
export class HomePageElevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
